<template>
  <div class="container">
    <div class="mx-auto">
      <div class="custom-logo">
        <img src="https://invoicesainet.blob.core.windows.net/images/J_Logo_Black_256x256.png" alt="App" width="128" />

        <span class="custom-title">Invoices AI</span>
      </div>
      <LearnMoreDetails />
    </div>
  </div>
</template>
<script>
import LearnMoreDetails from '@/components/marketing/LearnMoreDetails.vue'
export default {
  name: 'LoginView',
  components: {
    LearnMoreDetails
  }
}
</script>
<style lang="scss" scoped>
.custom-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%; // Ensures it takes full width of its parent container
  margin-bottom: 20px;
}
.custom-title {
  position: relative;
  font-size: 1.8rem;
  font-weight: bold;
  font-style: italic;
  color: #333;
  top: 25px;
  left: 10px;
}
</style>
